import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @cat:
// @name:
// @desc: 添加的一定是私有类型的 tag
// @error:
// ErrCategoryDupCreate
// ErrTagDupCreate
// @gen: t=add_model_db_proxy
// @gen_to: tag

/** @type {(r: commonv2.AddTagReq, b: any) => Promise<commonv2.AddTagRsp>} TypeScript syntax */

export function AddTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/AddTag",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCategoryDupCreate
// ErrTagDupCreate
// @gen: t=add_model_db_proxy
// @gen_to: tag
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.AddTagAdminReq, b: any) => Promise<commonv2.AddTagAdminRsp>} TypeScript syntax */

export function AddTagAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/AddTagAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 只能修改自己的私有标签
// @error:
// ErrCategoryDupCreate
// ErrTagDupSet
// @gen: t=set_model_db_proxy
// @gen_to: tag

/** @type {(r: commonv2.SetTagReq, b: any) => Promise<commonv2.SetTagRsp>} TypeScript syntax */

export function SetTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/SetTag",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCategoryDupCreate
// ErrTagDupSet
// @gen: t=set_model_db_proxy
// @gen_to: tag
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.SetTagAdminReq, b: any) => Promise<commonv2.SetTagAdminRsp>} TypeScript syntax */

export function SetTagAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/SetTagAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrTagNotFound
// @gen: t=get_model_db_proxy
// @gen_to: tag

/** @type {(r: commonv2.GetTagReq, b: any) => Promise<commonv2.GetTagRsp>} TypeScript syntax */

export function GetTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetTag",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: tag

/** @type {(r: commonv2.GetTagListReq, b: any) => Promise<commonv2.GetTagListRsp>} TypeScript syntax */

export function GetTagList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetTagList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: tag
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.GetTagListAdminReq, b: any) => Promise<commonv2.GetTagListAdminRsp>} TypeScript syntax */

export function GetTagListAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetTagListAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=del_model_db_proxy
// @gen_to: tag

/** @type {(r: commonv2.DelTagReq, b: any) => Promise<commonv2.DelTagRsp>} TypeScript syntax */

export function DelTag(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/DelTag",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=del_model_db_proxy
// @gen_to: tag
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.DelTagAdminReq, b: any) => Promise<commonv2.DelTagAdminRsp>} TypeScript syntax */

export function DelTagAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/DelTagAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCategoryDupCreate 分类已存在
// ErrCategoryParentNotFound 没有找到父节点
// ErrInvalidCategoryTree 非法分类树
// ErrCategoryNameExisted 分类名已存在
// @gen: t=add_model_db_proxy
// @gen_to: category
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.AddCategoryReq, b: any) => Promise<commonv2.AddCategoryRsp>} TypeScript syntax */

export function AddCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/AddCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCategoryNotFound 分类不存在
// @gen: t=get_model_db_proxy
// @gen_to: category
// svr options: (ext.UserType) = pub

/** @type {(r: commonv2.GetCategoryReq, b: any) => Promise<commonv2.GetCategoryRsp>} TypeScript syntax */

export function GetCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetCategory",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCategoryDupSet 分类已存在
// ErrCategoryCanNotMove 不可以移动
// ErrInvalidCategoryTree 非法分类树
// @gen: t=set_model_db_proxy
// @gen_to: category
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.SetCategoryReq, b: any) => Promise<commonv2.SetCategoryRsp>} TypeScript syntax */

export function SetCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/SetCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: category
// svr options: (ext.UserType) = pub

/** @type {(r: commonv2.GetCategoryListReq, b: any) => Promise<commonv2.GetCategoryListRsp>} TypeScript syntax */

export function GetCategoryList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetCategoryList",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCategoryNotLeaf 没有子
// ErrCategoryNotFound
// ErrInvalidCategoryTree 非法分类树
// @gen: t=del_model_db_proxy
// @gen_to: category
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.DelCategoryReq, b: any) => Promise<commonv2.DelCategoryRsp>} TypeScript syntax */

export function DelCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/DelCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: category
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.GetCategoryListAdminReq, b: any) => Promise<commonv2.GetCategoryListAdminRsp>} TypeScript syntax */

export function GetCategoryListAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetCategoryListAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: category
// svr options: (ext.UserType) = pub

/** @type {(r: commonv2.BatchGetCategoryListReq, b: any) => Promise<commonv2.BatchGetCategoryListRsp>} TypeScript syntax */

export function BatchGetCategoryList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/BatchGetCategoryList",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=add_model_db_proxy
// @gen_to: banner
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.AddBannerAdminReq, b: any) => Promise<commonv2.AddBannerAdminRsp>} TypeScript syntax */

export function AddBannerAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/AddBannerAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrBannerNotFound
// @gen: t=set_model_db_proxy
// @gen_to: banner
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.SetBannerAdminReq, b: any) => Promise<commonv2.SetBannerAdminRsp>} TypeScript syntax */

export function SetBannerAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/SetBannerAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: banner
// svr options: (ext.UserType) = pub

/** @type {(r: commonv2.GetBannerListReq, b: any) => Promise<commonv2.GetBannerListRsp>} TypeScript syntax */

export function GetBannerList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetBannerList",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @gen_to: banner
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.GetBannerListAdminReq, b: any) => Promise<commonv2.GetBannerListAdminRsp>} TypeScript syntax */

export function GetBannerListAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetBannerListAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=del_model_db_proxy
// @gen_to: banner
// svr options: (ext.UserType) = admin

/** @type {(r: commonv2.DelBannerAdminReq, b: any) => Promise<commonv2.DelBannerAdminRsp>} TypeScript syntax */

export function DelBannerAdmin(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/DelBannerAdmin",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 根据key拉取任务状态
// @desc:
// @error:
// ErrAsyncTaskNotFound 没有找到异步任务
// @ignore: all

/** @type {(r: commonv2.GetAsyncTaskStateReq, b: any) => Promise<commonv2.GetAsyncTaskStateRsp>} TypeScript syntax */

export function GetAsyncTaskState(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetAsyncTaskState",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrRequestUrlFail 网页请求失败
// ErrHtmlParseFail 网页解析失败
// ErrHtmlIpFail 网页不允许请求IP
// @freq: uid,300,20

/** @type {(r: commonv2.GetHtmlInfoByUrlReq, b: any) => Promise<commonv2.GetHtmlInfoByUrlRsp>} TypeScript syntax */

export function GetHtmlInfoByUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetHtmlInfoByUrl",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrAsyncTaskNotFound 没有找到异步任务
// @gen: t=get_model_list_db_proxy

/** @type {(r: commonv2.GetAsyncTaskListReq, b: any) => Promise<commonv2.GetAsyncTaskListRsp>} TypeScript syntax */

export function GetAsyncTaskList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetAsyncTaskList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: commonv2.DelAsyncTaskReq, b: any) => Promise<commonv2.DelAsyncTaskRsp>} TypeScript syntax */

export function DelAsyncTask(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/DelAsyncTask",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: commonv2.GetAsyncTaskReq, b: any) => Promise<commonv2.GetAsyncTaskRsp>} TypeScript syntax */

export function GetAsyncTask(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetAsyncTask",
    "auth": "1"
  }), o));
}
; // @cat: 根据ip获取地理位置
// @name:
// @desc:
// @error:
// @gen_to: utils

/** @type {(r: commonv2.Ip2GEOLocationReq, b: any) => Promise<commonv2.Ip2GEOLocationRsp>} TypeScript syntax */

export function Ip2GEOLocation(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/Ip2GEOLocation",
    "auth": "1"
  }), o));
}
; // @desc: 获取网站预览信息
// @gen_to: utils

/** @type {(r: commonv2.ParseWebLinkPreviewInfoReq, b: any) => Promise<commonv2.ParseWebLinkPreviewInfoRsp>} TypeScript syntax */

export function ParseWebLinkPreviewInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/ParseWebLinkPreviewInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: commonv2.GetMediaInfoReq, b: any) => Promise<commonv2.GetMediaInfoRsp>} TypeScript syntax */

export function GetMediaInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetMediaInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: commonv2.GetUserAgentReq, b: any) => Promise<commonv2.GetUserAgentRsp>} TypeScript syntax */

export function GetUserAgent(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GetUserAgent",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to:　short_url_link

/** @type {(r: commonv2.GenShortUrlLinkReq, b: any) => Promise<commonv2.GenShortUrlLinkRsp>} TypeScript syntax */

export function GenShortUrlLink(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/commonv2/GenShortUrlLink",
    "auth": "1"
  }), o));
}
;
var Commonv2Services = {
  AddTag: AddTag,
  AddTagAdmin: AddTagAdmin,
  SetTag: SetTag,
  SetTagAdmin: SetTagAdmin,
  GetTag: GetTag,
  GetTagList: GetTagList,
  GetTagListAdmin: GetTagListAdmin,
  DelTag: DelTag,
  DelTagAdmin: DelTagAdmin,
  AddCategory: AddCategory,
  GetCategory: GetCategory,
  SetCategory: SetCategory,
  GetCategoryList: GetCategoryList,
  DelCategory: DelCategory,
  GetCategoryListAdmin: GetCategoryListAdmin,
  BatchGetCategoryList: BatchGetCategoryList,
  AddBannerAdmin: AddBannerAdmin,
  SetBannerAdmin: SetBannerAdmin,
  GetBannerList: GetBannerList,
  GetBannerListAdmin: GetBannerListAdmin,
  DelBannerAdmin: DelBannerAdmin,
  GetAsyncTaskState: GetAsyncTaskState,
  GetHtmlInfoByUrl: GetHtmlInfoByUrl,
  GetAsyncTaskList: GetAsyncTaskList,
  DelAsyncTask: DelAsyncTask,
  GetAsyncTask: GetAsyncTask,
  Ip2GEOLocation: Ip2GEOLocation,
  ParseWebLinkPreviewInfo: ParseWebLinkPreviewInfo,
  GetMediaInfo: GetMediaInfo,
  GetUserAgent: GetUserAgent,
  GenShortUrlLink: GenShortUrlLink
};
export default Commonv2Services;